"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extend = void 0;

var _styledComponents = require("rebass/styled-components");

var _styledComponents2 = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var rebassPrimitives = {
  Box: _styledComponents.Box,
  Flex: _styledComponents.Flex,
  Text: _styledComponents.Text,
  Heading: _styledComponents.Heading,
  Link: _styledComponents.Link,
  Button: _styledComponents.Button,
  Image: _styledComponents.Image,
  Card: _styledComponents.Card
}; // A map of Rebass' component inheritance.
// When adding a style prop to `Box` use this to calculate which style props should
// also be addded to the components that extend it.
// E.g.: Adding `display` to Box also adds it to `Flex`, `Text`, etc.

var inheritanceMap = {
  Box: ['Flex', 'Text', 'Heading', 'Link', 'Button', 'Image', 'Card'],
  Text: ['Heading']
};

var mergeInheritedStyleProps = function mergeInheritedStyleProps(_ref) {
  var componentName = _ref.componentName,
      config = _ref.config;
  return Object.keys(inheritanceMap).filter(function (baseComponentName) {
    return inheritanceMap[baseComponentName].includes(componentName);
  }).reduce(function (acc, baseComponentName) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(config[baseComponentName] || []));
  }, []);
};

var buildConfig = function buildConfig(config) {
  return Object.keys(rebassPrimitives).reduce(function (newConfig, componentName) {
    var styleProps = mergeInheritedStyleProps({
      componentName: componentName,
      config: config
    });
    return _objectSpread(_objectSpread({}, newConfig), {}, _defineProperty({}, componentName, [].concat(_toConsumableArray(config[componentName] || []), _toConsumableArray(styleProps))));
  }, {});
};

var extendComponent = function extendComponent(component, componentName, styleProps) {
  var newComponent = (0, _styledComponents2.default)(component).withConfig({
    displayName: componentName
  })([styleProps]);
  newComponent.propTypes = _objectSpread(_objectSpread({}, component.propTypes), styleProps.reduce(function (acc, prop) {
    return _objectSpread(_objectSpread({}, acc), prop.propTypes);
  }, {}));
  return newComponent;
};

var extend = function extend(extensions) {
  var config = buildConfig(extensions);
  return Object.keys(rebassPrimitives).reduce(function (acc, componentName) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, componentName, extendComponent(rebassPrimitives[componentName], componentName, config[componentName])));
  }, {});
};

exports.extend = extend;